"use client";

import { c as _c } from "react/compiler-runtime";
import { IconHelp } from "@tabler/icons-react";
import dynamic from "next/dynamic";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

// react-markdown only renders inside the click-opened dialog — load it on
// demand so it stays out of the PDP's initial bundle.
const OptionHelpContent = dynamic(() => import("./OptionHelpContent"), {
  ssr: false
});
interface Props {
  id: string;
  label: string;
  content: string;
}
export default function OptionHelpDialog(t0) {
  const $ = _c(22);
  const {
    id,
    label,
    content
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconHelp className="size-5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <Button variant="ghost" size="icon" type="button" className="shrink-0">{t1}<span className="sr-only">Help for {label}</span></Button>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== id || $[4] !== t2) {
    t3 = <DialogTrigger asChild={true} aria-controls={id}>{t2}</DialogTrigger>;
    $[3] = id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== label) {
    t4 = <DialogTitle className="sr-only">{label} help</DialogTitle>;
    $[6] = label;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== label) {
    t5 = label.toLowerCase();
    $[8] = label;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <DialogDescription className="sr-only">Additional information about {t5}.</DialogDescription>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== content) {
    t7 = <div className="prose max-w-none text-wrap"><OptionHelpContent content={content} /></div>;
    $[12] = content;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== id || $[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <DialogContent id={id} className="max-h-[80dvh] overflow-y-auto">{t4}{t6}{t7}</DialogContent>;
    $[14] = id;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t3 || $[20] !== t8) {
    t9 = <Dialog>{t3}{t8}</Dialog>;
    $[19] = t3;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}